export default __webpack_public_path__ + "static/media/landing_image.094b1fdf.svg";